import React, { Component } from 'react';
import "./style.css";

// import Tile from "arc-design/components/tile";
import { 
  // HelpText, 
  QlikClearSelections, 
  QdtComponent 
} from "../../components";

export default class CityProfile extends Component {

  render() {
    return (
    <div className="cityProfile">    
           
      {/* <div className="subsectionTitle">Targets on renewable energy or electricity</div> */}

        <div className="chartwithfooter">
          <div className="FilterTitleTeal">Filter by:</div>   
          <div className="chart">
            <QdtComponent props={{
                id: "nLpsP",     /*filter*/ 
                height: "40px",                  
            }} />
          </div> 
          <div className="clear">
            <QlikClearSelections />
          </div> 
          <div className="chart">
              <div className="chartTitleTeal">
                <QdtComponent type="QdtKpi" props={{ cols: ["= Region & ' Peer Networks'"] }} />
              </div>            
              <QdtComponent props={{                                      
                id: "VbuXzJG",      /*container*/ 
                height: "500px",
                noSelections: true
              }} />
          </div> 
          <div className="footnote">
            <div className="footitem"> Zoom in/out to view the distribution of networks across the regions, or use the filters above to explore peer networks. Click on the "Links" tab for more details on each organisation. </div>
          </div> 
        </div>
      {/* </div> */}

    </div>      

    );
  }
}
